
import { Dialog } from "vant";
import Vue from 'vue'

function requestApiPath(response) {
  var cfg = response && response.config ? response.config : {};
  var url = '';
  if (response && response.request && response.request.responseURL) {
    url = response.request.responseURL;
  } else {
    url = cfg.url || '';
    if (cfg.baseURL && !/^https?:/i.test(url)) {
      url = String(cfg.baseURL).replace(/\/?$/, '/') + String(url).replace(/^\//, '');
    }
  }
  var path = String(url).split('?')[0];
  try {
    if (/^https?:/i.test(path)) path = new URL(path).pathname;
  } catch (e) {}
  return path.replace(/^\/+/, '').replace(/^v1\//, '');
}

function isLandlordOwnApi(response) {
  return /^landlord\/(me|myRooms|saveProfile|savePassword|dashboard|monthHide|contract|roomCalendar|notices|ownerStay|publications|settlement)(\/|$)/.test(requestApiPath(response));
}

export default {
  name: "Index",
  components: {
  },
  data() {
    return {
      disabledScroll: false
    };
  },
  computed: {
    showStaffMenu() {
      var path = this.$route.path || '';
      return path.indexOf('/owner') !== 0;
    }
  },
  watch: {
    '$route.path': function () {
      this.syncOwnerBody();
    }
  },
  methods: {
    syncOwnerBody() {
      var path = (this.$route && this.$route.path) || '';
      var onOwner = path === '/owner' || path.indexOf('/owner/') === 0;
      var onStaffLandlord = path === '/pl_landlord' || path.indexOf('/pl_landlord_') === 0;
      if (onOwner) {
        document.body.classList.add('pc');
        document.body.classList.add('owner-portal');
      } else {
        document.body.classList.remove('owner-portal');
      }
      document.body.classList.remove('pl-landlord');
      if (onOwner || onStaffLandlord) {
        document.body.classList.add('beautyscroll');
      } else {
        document.body.classList.remove('beautyscroll');
      }
    },
    afterLogin() {
      Vue.prototype.U = S.get('_m');
      axios.defaults.headers.common["Token"] = this.U.token;
    },
    applyTokenForHash() {
      var owner = /#\/owner/.test(location.hash) && !/#\/owner\/mock/.test(location.hash);
      if (owner) {
        var landlord = S.get('_landlord');
        if (landlord && landlord.token) {
          Vue.prototype.U = landlord;
          axios.defaults.headers.common["Token"] = landlord.token;
          return true;
        }
        axios.defaults.headers.common["Token"] = '';
        return false;
      }
      if (S.get('_m')) {
        Vue.prototype.U = S.get('_m');
        axios.defaults.headers.common["Token"] = this.U.token;
        return true;
      }
      return false;
    }
  },
  created() {

    let t = this;
    t.syncOwnerBody();

    document.addEventListener('contextmenu', function (e) {
      var isPC = !/Android|iPhone|iPad|iPod|Mobile|KIS-iOS/i.test(navigator.userAgent);
      if (isPC) {
        return;
      }
      if (e.target.tagName !== 'INPUT' && e.target.tagName && !e.target.classList.contains('contextmenu-able')) {
        e.preventDefault();
      }
    });

    window._v = {};
    window._v.attVersion = '0.9a';
    window._v.sysVersion = '0.69';
    window._v.buildVersion = 121;

    Vue.prototype.showAttVersion = function () {
      A.show(window._v.attVersion, '現在のバージョン', 'info');
    };
    Vue.prototype.showSysVersion = function () {
      A.show(window._v.sysVersion, '現在のバージョン', 'info');
    };
    Vue.prototype.startUrl = location.href;
    Vue.prototype.busying = false;

    Vue.prototype.afterLogin = t.afterLogin;

    Vue.prototype.appMode = '';

    Vue.prototype.setAppMode = function (name) {
      Vue.prototype.appMode = name;
    }

    let imgKey = 0;
    Vue.prototype.newImageKey = function () {
      return imgKey++;
    }

    Dialog.setDefaultOptions({ confirmButtonText: '确认' });

    axios.defaults.baseURL = 'https://hk.kyoran.jp/v1/';

    axios.interceptors.request.use(function (config) {
      var owner = /#\/owner/.test(location.hash) && !/#\/owner\/mock/.test(location.hash);
      var token = '';
      if (owner) {
        var landlord = S.get('_landlord');
        if (landlord && landlord.token) token = landlord.token;
      } else {
        var employee = S.get('_m');
        if (employee && employee.token) token = employee.token;
      }
      if (token) {
        config.headers.Token = token;
      } else if (config.headers) {
        delete config.headers.Token;
      }
      return config;
    });

    axios.interceptors.response.use(function (response) {
      if (response.data && response.data.status == -5) {
        if (/#\/owner\/mock|#\/pl_landlord_mock/.test(location.hash)) {
          return response;
        }
        var onOwner = /#\/owner/.test(location.hash) && !/#\/owner\/mock/.test(location.hash);
        if (onOwner) {
          if (isLandlordOwnApi(response)) {
            localStorage.removeItem('_landlord');
            location.replace('/#/signIn');
          }
          return response;
        }
        localStorage.removeItem('_m');
        location.replace('/#/signIn');
      }
      return response;
    }, function (error) {
      if (error.response.status === 401) {
        console.error('Unauthorized access, please login again.');
      } else if (error.response.status === 403) {
        console.error('Access forbidden.');
      }
      return Promise.reject(error);
    });

    Vue.prototype.wsURL = 'wss://hk.kyoran.jp:8765/';

    if (/localhost|dev|192\.168\.31\.7/.test(location.host)) {
      axios.defaults.baseURL = '//localhost/kyoran/api/public/v1/';
      Vue.prototype.wsURL = 'ws://localhost:8765/';
    }

    var onOwnerApp = /#\/owner/.test(location.hash) && !/#\/owner\/mock/.test(location.hash);
    if (onOwnerApp) {
      if (!S.get('_landlord') || !S.get('_landlord').token) {
        location.replace('/#/signIn');
      } else {
        t.applyTokenForHash();
      }
    } else if (!t.applyTokenForHash()) {
      Vue.prototype.U = {
        firstname: '',
        lastname: '',
        email: '',
        tel: '',
        last_logged_at: '',
        birthday: '',
        entry_date: '',
        emergency_tel: '',
        desc: '',
        gender: '',
        sn: '',
        token: '',
        business_ids: '',
        country: '',
        rc_img_url: '',
        id: '',
        avatar_url: '',
        rating: 0,
        count_cleaned: 0,
        count_sup: 0,
        role: 1,
        count_clock_in: 0,
        clock_in_reviewer: 0,
        is_mgr: 0,
        is_att_mgr:0,
        att_days: 0,
        grant: {
          "clock_in": 0,
          "work_online": 0,
          "leave_review": 1,
          "clock_in_review": 1,
          "att_schedule_review": 1,
          "second_review": 1,
          "daily_report": 0,
          "clean_mgr": 0,
          "paid_leave": 0,
          "unpaid_leave": 0,
          "event_leave": 0,
          "field_work": 0,
          "att_shift": 0
        },
        is_driver: 0,
        is_cleaner: 0,
        is_courier: 0,
      };
      if (!/form|form-v2|read|working_report|business_form|signup|logo|owner\/mock|pl_landlord/.test(location.hash))
        location.replace('/#/signIn');
    }

    axios.get('versions').then(res => {
      if (res.data && res.data.build && res.data.build != window._v.buildVersion) {
        A.show('「確認」をクリックすると、バージョンチェックを行い、最新版に更新します。<br><br>このメッセージを頻繁に見える場合は、管理者にお問い合わせしてください。', 'バージョンチェック', 'warning').then(res2 => {
          location.replace('/?v=' + res.data.build + '_' + (new Date()).valueOf());
        });
      }
    });

  },
  mounted() {
    let t = this;

  },

};
